import React, { useMemo } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCircleUser,
    faTimesCircle,
    faBuilding,
    faPlusCircle,
    faMinusCircle,
    faFileArrowUp,
    faGlobe,
    faUserGroup,
    faCheckCircle
} from '@fortawesome/free-solid-svg-icons';
import RoleCheckboxList from './RoleCheckboxList';
import './edit-user-modal.scss';

// entity Arr for UI display on rows for scrollable
const entityTypeArr = { 2: 'Network', 3: 'Chain', 4: 'Club' };

// retrieve the correct key for UI display and mapping purposes
// for the edit user entity table/scrollable
const findCorrectKey = (e) => {
    if (e?.EntityType === 2) return e.EntityID;
    if (e?.EntityType === 3) return e.ChainID;
    return e.ClubID;
};

// retrieve the correct icon for UI display and mapping purposes
// for the edit user entity table/scrollable
const findCorrectIcon = (e) => {
    if (e?.EntityType === 2) return faGlobe;
    if (e?.EntityType === 3) return faBuilding;
    return faUserGroup;
};

export default function EditUserModal({
    show,
    onClose,

    // data/state
    editUserData,
    status,
    error,

    selectedEmail,
    onSelectedEmailChange,

    updatedRoles,
    onRolesChange,

    entityTree,
    onRemoveEntity,

    isAddToggled,
    onToggleAddMode,

    isNetworksActive,
    isChainsActive,
    isClubsActive,
    handleBtnGroupChange,

    entityAddData,
    entitySearchLike,
    onEntitySearchLikeChange,
    entityIDSearch,
    onEntityIDSearchChange,

    countryIdFilter,
    onCountryIdFilterChange,

    addedEntities,
    onAddEntity,
    entityKey,
    isEntityAdded,

    onOpenUploadModal,

    onSave,
    isDirty,

    isUKUser
}) {
    const headerEmail = useMemo(
        () => editUserData?.Email ?? selectedEmail ?? '',
        [editUserData, selectedEmail]
    );

    return (
        <Modal className="dialog-container" show={show} onHide={onClose} centered>
            <Modal.Header closeButton>
                <FontAwesomeIcon icon={faCircleUser} className="editing-user-icon" />
                <Modal.Title>Edit User:</Modal.Title>
                <div className="edit-user-header">{headerEmail}</div>
            </Modal.Header>

            <Modal.Body className="dialog-body">
                {status === 'loading' && <div>Loading user data...</div>}
                {status === 'failed' && <div className="text-danger">{error}</div>}
                {status === 'succeeded' && editUserData && (
                    <>
                        {/* email */}
                        <label className="fw-bold">Email</label>
                        <div className="form-outline mb-4">
                            <input
                                className="form-control form-control-lg"
                                onChange={(e) => onSelectedEmailChange(e.target.value)}
                                type="text"
                                value={selectedEmail ?? ''}
                            />
                        </div>

                        {/* eoles */}
                        <div className="mb-3">
                            <div className="fw-bold">Roles</div>
                            <RoleCheckboxList
                                initialRoles={editUserData?.RoleIds ?? []}
                                onChange={(roles) => onRolesChange(roles)}
                            />
                        </div>

                        {/* entities */}
                        <div className="mb-3 eu-entity-tree-container">
                            <div className="networks-title">
                                <FontAwesomeIcon className="eu-entity-icon" icon={faGlobe} />
                                Add Venues

                                {isAddToggled ? (
                                    <button
                                        type="button"
                                        className="add-entities-btn"
                                        onClick={onToggleAddMode}
                                        title="Add Entities"
                                    >
                                        Add
                                        <FontAwesomeIcon className="add-entities-btn-icon" icon={faPlusCircle} />
                                    </button>
                                ) : (
                                    <button
                                        type="button"
                                        className="add-entities-btn"
                                        onClick={onToggleAddMode}
                                        title="Return"
                                    >
                                        Return to List
                                        <FontAwesomeIcon className="add-entities-btn-icon" icon={faMinusCircle} />
                                    </button>
                                )}
                            </div>

                            {isAddToggled ? (
                                <ul className="eu-entity-tree">
                                    {entityTree.map((entity) => {
                                        const key = findCorrectKey(entity);
                                        return (
                                            <li key={`${entity.EntityType}-${key}`} className="eu-entity-row">
                                                <div className="eu-entity-line">
                                                    <span className="eu-entity-label">
                                                        <FontAwesomeIcon className="eu-entity-icon" icon={findCorrectIcon(entity)} />
                                                        {entityTypeArr[entity.EntityType]}: {key} - {entity.EntityName}
                                                    </span>

                                                    <button
                                                        type="button"
                                                        className="icon-btn remove"
                                                        onClick={() => onRemoveEntity(entity)}
                                                        title="Remove"
                                                    >
                                                        <FontAwesomeIcon className="remove-icon" icon={faTimesCircle} />
                                                    </button>
                                                </div>
                                            </li>
                                        );
                                    })}
                                </ul>
                            ) : (
                                /* BUTTON GROUP FOR FILTERING ENTITIES */
                                <div>
                                    <div className="eu-btn-group">
                                            {isUKUser && <button type="button" className={isNetworksActive ? 'group-btn-active' : 'btn-group-btn'} onClick={() => handleBtnGroupChange('network')}>
                                                <FontAwesomeIcon className={isNetworksActive ? 'btn-group-icon-active' : 'btn-group-icon'} icon={faGlobe} />
                                                Networks
                                            </button>}
                                            {isUKUser && <button type="button" className={isChainsActive ? 'group-btn-active' : 'btn-group-btn'} onClick={() => handleBtnGroupChange('chain')}>
                                                <FontAwesomeIcon className={isChainsActive ? 'btn-group-icon-active' : 'btn-group-icon'} icon={faBuilding} />
                                                Chains
                                            </button>}
                                            <button type="button" className={isClubsActive ? 'group-btn-active' : 'btn-group-btn'} onClick={() => handleBtnGroupChange('club')}>
                                                <FontAwesomeIcon className={isClubsActive ? 'btn-group-icon-active' : 'btn-group-icon'} icon={faUserGroup} />
                                                Clubs
                                        </button>
                                            <button type="button" className="btn-group-btn" onClick={onOpenUploadModal}>
                                            <FontAwesomeIcon className="btn-group-icon" icon={faFileArrowUp} />
                                                Upload List
                                            </button>
                                            <select
                                                className="btn-group-select"
                                                value={countryIdFilter}
                                                onChange={(e) => onCountryIdFilterChange?.(Number(e.target.value))}
                                                title="Filter by Country"
                                            >
                                                <option value={1}>US</option>
                                                <option value={2}>UK</option>
                                            </select>
                                    </div>
                                    <div className="entity-search-container">
                                            <span className="form-outline mb-4 entity-search-name">
                                                <input
                                                    className="form-control form-control-lg entity-search-name"
                                                    onChange={(e) => onEntitySearchLikeChange(e.target.value)}
                                                    type="text"
                                                    value={entitySearchLike ?? ''}
                                                    placeholder="Search by Name"
                                                />
                                            </span>
                                            <span className="form-outline mb-4 entity-searchid">
                                                <input
                                                    className="form-control form-control-lg entity-search-id"
                                                    onChange={(e) => onEntityIDSearchChange(e.target.value)}
                                                    type="text"
                                                    value={entityIDSearch ?? ''}
                                                    placeholder="Find by ID"
                                                />
                                            </span>
                                        </div>
                                        {entityAddData?.length === 250 && <label>250+ record(s) found:</label>}
                                        {entityAddData?.length < 250 && <label>{entityAddData?.length} record(s) found:</label>}
                                    {/* entity list for add */}
                                    <ul className="eu-entity-tree">
                                            {entityAddData?.map((entity) => {
                                            // determines whether the entity is a network/chain/club for add/remove
                                            const key = findCorrectKey(entity);
                                            // check the array of added entities to diplsya the correct button and tooltip
                                            const added = isEntityAdded(entity);
                                            return (
                                                <li key={`${entity.EntityType}-${key}`} className="eu-entity-row">
                                                    <div className="eu-entity-line">
                                                        <span className="eu-entity-label">
                                                            <FontAwesomeIcon className="eu-entity-icon" icon={findCorrectIcon(entity)} />
                                                            {entityTypeArr[entity.EntityType]}: {key} - {entity.EntityName}
                                                        </span>

                                                        <button
                                                            type="button"
                                                            className="icon-btn remove"
                                                            onClick={() => (added ? onRemoveEntity(entity) : onAddEntity(entity))}
                                                            title={added ? "Added" : "Add"}
                                                        >
                                                            <FontAwesomeIcon className="remove-icon" icon={added ? faCheckCircle : faPlusCircle} />
                                                        </button>
                                                    </div>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                            )}
                        </div>
                    </>
                )}
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={onSave} disabled={!isDirty}>
                    Save
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
